import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Link } from 'foundations-components/transitional/components/Link';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import QuizMeAnswers from './QuizMeAnswers';
import QuizMeCompletion from './QuizMeCompletion';
import { useQuizMeSession } from '../utils/quizMeUtils';
import { DIFFICULTY_CONFIG } from '../interactiveEducationConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuizMeQuestions = ({
  additionalTracking,
  difficultyLevel,
  lessonContentId,
  contentType,
  handleRestartQuiz,
  handleSelectAnswerIndexChange,
  onChangeDifficulty,
  primaryContentId,
  questionAnswered,
  quizQuestions,
  selectedAnswerIndex
}) => {
  const {
    getQuizState
  } = useQuizMeSession();
  const quizSession = getQuizState(lessonContentId !== null && lessonContentId !== void 0 ? lessonContentId : primaryContentId, contentType);
  const questionIndex = quizSession !== null && quizSession !== void 0 && quizSession.questionIndex ? questionAnswered ? quizSession.questionIndex - 1 : quizSession.questionIndex : 0;
  const quizLength = quizQuestions.length;
  const progress = questionIndex < quizLength ? questionIndex + 1 : quizLength;
  if (!quizSession) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.loadingQuiz"
      }),
      showLabel: true
    });
  }
  return /*#__PURE__*/_jsxs(ScrollContainer, {
    blockSize: "480px",
    maxHeight: 480,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      marginInlineEnd: "700",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "300",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.quizMe"
          })
        }), difficultyLevel && /*#__PURE__*/_jsx(Badge, {
          use: "lorax",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: DIFFICULTY_CONFIG[difficultyLevel].title
          })
        }), difficultyLevel && onChangeDifficulty && /*#__PURE__*/_jsx(Link, {
          onClick: onChangeDifficulty,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.difficulty.changeDifficulty"
          })
        })]
      }), questionIndex < quizLength && /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.interactiveEducation.quiz.progress",
          options: {
            progress,
            total: quizQuestions.length
          }
        })
      })]
    }), quizLength === 0 ? /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      padding: "800",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.interactiveEducation.quiz.loadingQuiz"
        }),
        showLabel: true
      })
    }) : questionIndex < quizLength ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        marginBlock: "800",
        marginInlineEnd: "700",
        children: /*#__PURE__*/_jsx("b", {
          children: quizQuestions[questionIndex].questionTitle
        })
      }), /*#__PURE__*/_jsx(QuizMeAnswers, {
        handleSelectAnswerIndexChange: handleSelectAnswerIndexChange,
        questionAnswered: questionAnswered,
        questionIndex: questionIndex,
        quizQuestions: quizQuestions,
        selectedAnswerIndex: selectedAnswerIndex
      })]
    }) : /*#__PURE__*/_jsx(QuizMeCompletion, {
      additionalTracking: additionalTracking,
      correctAnswers: quizSession.correctAnswers,
      difficultyLevel: difficultyLevel,
      handleRestartQuiz: handleRestartQuiz,
      totalQuestions: quizLength
    })]
  });
};
export default QuizMeQuestions;